/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
import Vuesax from 'vuesax'
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import * as VueGoogleMaps from "vue2-google-maps";
import 'vuesax/dist/vuesax.css'

Vue.config.productionTip = false;

Vue.use(NowUiKit);
Vue.use(Vuesax, {
  // options here
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCKABi_XOoL8SV09B6ZhdH5l0eJkiJfFQc",
    libraries: "" // necessary for places input
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
